import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import { CorpTypeList3 } from "../../assets/data/Constants";
import { useGetNowDate } from "../../utils/useTools";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import "./_style.scss";

const stepper = ["内容入力", "機構へ提出"];

const getNowDate = useGetNowDate;
const nowDate = new Date(
  getNowDate().year + "/" + (getNowDate().month + 1) + "/" + getNowDate().date
);

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "lineTitle",
    type: "lineTitle",
    lineTitle: "",
  },
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
    showLine: false,
  },
  {
    keyword: "lineTitle",
    type: "lineTitle",
    lineTitle: "",
  },
  {
    title: "契約者名称の変更年月日",
    keyword: "nameChangeDate",
    type: "date",
    requiredIcon: false,
    helpicon: true,
    helpText:
      "履歴事項全部証明書に記載されている変更日を登録してください。直接入力していただくか、「カレンダーボタン」にて日付を選択してください。",
    minDate: new Date("1900/1/1"),
    maxDate: nowDate,
  },
  {
    title: "（新）経営者種別",
    keyword: "newType",
    type: "selectForm",
    selectPropsList: TkGetCodeList(CorpTypeList3),
    requiredIcon: false,
    helpicon: true,
    helpText: (
      <>
        "社会福祉法人以外の法人格へ変更する場合は、画面下の「お問い合わせフォーム」から問い合わせをしてください。
        <br />
        ※法人格の変更は共済契約の解除に該当します。詳しくは
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫共済契約者の要件について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
      </>
    ),
  },
  {
    title: "（旧）経営者種別",
    keyword: "oldType",
    type: "text",
    requiredIcon: false,
    helpicon: false,
  },
  {
    title: "（新）契約者名称（ｶﾅ）",
    keyword: "newNameKana",
    type: "label",
    requiredIcon: false,
    helpicon: false,
    inputProps: {
      maxLength: 255,
    },
  },

  {
    title: "（新）契約者名称",
    keyword: "newName",
    type: "label",
    requiredIcon: false,
    helpicon: false,
    inputProps: {
      maxLength: 60,
    },
    explanatoryInTitle: "※法人格は不要です",
  },
  {
    title: "（旧）契約者名称",
    keyword: "oldName",
    type: "text",
    requiredIcon: false,
    helpicon: false,
  },
  {
    title: "代表者職名",
    keyword: "directorTitle",
    type: "label",
    requiredIcon: false,
    helpicon: true,
    helpText: "代表者の役職名（理事長、会長等）を入力してください。",
    inputProps: {
      maxLength: 85,
    },
  },
  {
    title: "代表者氏名",
    keyword: "directorName",
    type: "label",
    requiredIcon: false,
    helpicon: true,
    helpText: "代表者（理事長、会長等）の氏名を入力してください。",
    inputProps: {
      maxLength: 30,
    },
  },
  {
    title: "履歴事項全部証明書（写）",
    keyword: "historyCertificate",
    type: "text",
    helpicon: true,
    helpText:
      "共済契約者の名称を変更した場合は、確認書類として履歴事項全部証明書（写）を添付してください。",
  },
  {
    keyword: "lineTitle",
    type: "lineTitle",
    lineTitle: "",
  },
  {
    title: "主たる事務所の所在地の変更年月日",
    keyword: "locationChangeDate",
    type: "date",
    requiredIcon: false,
    helpicon: true,
    helpText:
      "履歴事項全部証明書に記載されている変更年月日を登録してください。直接入力していただくか、「カレンダーボタン」にて日付を選択してください。",
    minDate: new Date("1900/1/1"),
    maxDate: nowDate,
  },
  {
    title: "（新）郵便番号",
    keyword: "zipcode",
    type: "addressSearch",
    requiredIcon: false,
    helpicon: false,
  },

  {
    title: "（新）主たる事務所の所在地",
    keyword: "newLocation",
    type: "locationGroup",
    valueObject: {
      prefectures: "",
      city: "",
      address: "",
    },
    requiredIcon: false,
    helpicon: false,
  },
  {
    title: "（旧）主たる事務所の所在地",
    keyword: "oldLocation",
    type: "text",
    requiredIcon: false,
    helpicon: false,
  },
  {
    keyword: "lineTitle",
    type: "lineTitle",
    lineTitle: "",
  },

  {
    title: "共済契約証書再交付申出",
    keyword: "againReissue",
    type: "nodeInLine",
    requiredIcon: false,
    helpicon: true,
    helpText:
      "契約証書を紛失した場合に再交付できます。なお、契約者名称または主たる事務所の所在地が変更になったことによる再交付の必要はありません。",
  },
];

const schema = {
  changeDate: {
    minDate: {
      value: new Date("1900/1/1"),
      message: TkPropertyMessageGet("TKMSG_SCR0050E", "1900/1/1"),
    },
    maxDate: {
      value: nowDate,
      message: TkPropertyMessageGet(
        "TKMSG_SCR0051E",
        nowDate.getFullYear() +
          "/" +
          (nowDate.getMonth() + 1) +
          "/" +
          nowDate.getDate
      ),
    },
  },
  newNameKana: {
    pattern: {
      value: /^[ｧ-ﾝｦﾞﾟ\s-]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0054E"),
    },
    maxLength: {
      value: 255,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "255"),
    },
  },
  newName: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 60,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "60"),
    },
  },
  directorTitle: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  directorName: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 30,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "30"),
    },
  },
  zipcode: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    minLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
  },
  newLocation: {
    validate: (data: any) => {
      let error = {
        prefectures: "",
        city: "",
        address: "",
      };

      error = {
        prefectures: "",
        city:
          data.city.length > 20
            ? TkPropertyMessageGet("TKMSG_SCR0046E", "20")
            : // eslint-disable-next-line no-control-regex
            !data.city.match(/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/)
            ? TkPropertyMessageGet("TKMSG_SCR0061E")
            : "",
        address:
          data.address.length > 85
            ? TkPropertyMessageGet("TKMSG_SCR0046E", "85")
            : // eslint-disable-next-line no-control-regex
            !data.address.match(/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/)
            ? TkPropertyMessageGet("TKMSG_SCR0061E")
            : "",
      };

      const isErrorEmpty = Object.values(data).every((value) => value === "");
      if (isErrorEmpty) {
        return;
      }

      if (error.city !== "" || error.address !== "") {
        return JSON.stringify(error);
      }
    },
  },
  locationChangeDate: {
    minDate: {
      value: new Date("1900/1/1"),
      message: TkPropertyMessageGet("TKMSG_SCR0050E", "1900/1/1"),
    },
    maxDate: {
      value: nowDate,
      message: TkPropertyMessageGet(
        "TKMSG_SCR0051E",
        nowDate.getFullYear() +
          "/" +
          (nowDate.getMonth() + 1) +
          "/" +
          nowDate.getDate
      ),
    },
  },
};

export { stepper, fakeTableList, schema };
